import * as React from "react";
import LoginPopup from "../generic/loginPopup";
import DeviceContext from "../../service/indentifyDevice";
import Loader from "../../generic/loader";
import "../../../assets/scss/components/login/loginScreen/loginLoaderScreen.scss";
import logo from "../../../assets/images/logo_white.jpg";

export interface ILoginLoaderScreenProps {}

const LoginLoaderScreen: React.FC<ILoginLoaderScreenProps> = (props) => {
	return (
		<LoginPopup
			leftHeaderContent={!DeviceContext().isDesktop ? <img src={logo} alt="nuvama" className="nuvama_logo"/> : undefined}
			centerHeaderContent={DeviceContext().isDesktop ? <img src={logo} alt="nuvama" className="nuvama_logo"/> : undefined}
			className="change_pw_scrn"
		>
			<div className="login_loader_wrap">
				<Loader size={100} color="blue" />
			</div>
		</LoginPopup>
	);
};

export default LoginLoaderScreen;
